export interface CategoryItem {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export const categories: CategoryItem[] = [
  {
    id: 'singing',
    name: '网红歌唱赛',
    icon: 'ri-mic-2-line',
    desc: '聚焦网络唱将的巅峰对决，从翻唱金曲到原创舞台，聆听最动人的声音。',
  },
  {
    id: 'dance',
    name: '网红舞蹈赛',
    icon: 'ri-fire-line',
    desc: '街舞、国风、拉丁同台竞技，见证舞者用身体语言点燃全网的瞬间。',
  },
  {
    id: 'pk',
    name: '直播PK赛',
    icon: 'ri-live-line',
    desc: '人气主播连麦对垒，团队与个人赛制轮番上演，实时热度持续飙升。',
  },
  {
    id: 'ecommerce',
    name: '网红带货赛',
    icon: 'ri-shopping-bag-3-line',
    desc: '直播间里的销量战场，助农、国货、数码多赛道比拼带货实力。',
  },
  {
    id: 'talent',
    name: '才艺挑战赛',
    icon: 'ri-star-smile-line',
    desc: '魔术、乐器、脱口秀等多元才艺集中亮相，素人也能一夜出圈。',
  },
  {
    id: 'charity',
    name: '公益主播赛',
    icon: 'ri-heart-3-line',
    desc: '用直播传递温暖，公益助农与校园计划让流量变成真实的善意。',
  },
];

export const regions: string[] = [
  '全国',
  '北京',
  '上海',
  '广东',
  '浙江',
  '江苏',
  '四川',
  '湖南',
  '湖北',
  '山东',
];

export const timeRanges = [
  { value: '1m', label: '近一月' },
  { value: '3m', label: '近三月' },
  { value: '1y', label: '近一年' },
];

export const sortOptions = [
  { value: 'latest', label: '发布时间由新到旧' },
  { value: 'hot', label: '按热门程度' },
];